function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".bespoken_menu_dots_svg__cls-1{fill:#90a1ba}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "bespoken_menu_dots_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "bespoken_menu_dots_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("rect", {
  className: "bespoken_menu_dots_svg__cls-1",
  width: 3.83,
  height: 3.83,
  rx: 1.92,
  ry: 1.92
}), React.createElement("rect", {
  className: "bespoken_menu_dots_svg__cls-1",
  y: 6.08,
  width: 3.83,
  height: 3.83,
  rx: 1.92,
  ry: 1.92
}), React.createElement("rect", {
  className: "bespoken_menu_dots_svg__cls-1",
  y: 12.17,
  width: 3.83,
  height: 3.83,
  rx: 1.92,
  ry: 1.92
})));

var SvgBespokenMenuDots = function SvgBespokenMenuDots(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 3.83 16"
  }, props), _ref, _ref2);
};

export default SvgBespokenMenuDots;